// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1_7hq","cls2":"LoggedInDiscoveryPage-cls2_gCm LoggedInDiscoveryPage-cls1_7hq"};